import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const Notifications = (props) => {
	const [notification, setNotification] = useState({});

	const { success, warning, error } = useSelector(
		(state) => state.notifications
	);

	useEffect(() => {
		if (success) {
			setNotification(success);
		}
		if (warning) {
			setNotification(warning);
		}
		if (error) {
			setNotification(error);
		}
	}, [success, warning, error]);

	useEffect(() => {
		if (!notification.content) {
			return;
		}

		if (notification.hideDelay > 0) {
			const timeout = setTimeout(() => {
				setNotification({ progress: 0 });
			}, notification.hideDelay);
			return () => clearTimeout(timeout);
		}
	}, [notification]);

	return (
		<>
			{props.children}
			<div className="notifications">
				<div
					className={
						'notification is-' +
						(notification.color || 'info') +
						' ' +
						(notification.visible ? 'is-visible' : '')
					}>
					<div
						className={
							'notification-title' + (notification.title ? '' : ' is-hidden')
						}>
						{notification.title}
					</div>
					<div className="notification-body">
						<span
							className={
								'notification-icon' +
								(notification.icon ? ' fz fz-' + notification.icon : '')
							}
						/>
						<div className="notification-content">{notification.content}</div>
					</div>
					<progress
						className={
							'progress is-' +
							(notification.color || 'info') +
							(notification.progress >= 0 ? '' : ' is-hidden')
						}
						value={notification.progress}
						max="100"
					/>
				</div>
			</div>
		</>
	);
};
export default Notifications;
